import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import i18n from "i18next";
import { getToken } from "../../helpers/tokenHelpers";

export const createApiClient = (
  config: AxiosRequestConfig = {},
): AxiosInstance => {
  const http = axios.create(config);

  http.interceptors.request.use(async (config: any) => {
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers.post["ngrok-skip-browser-warning"] = "69420";

    // Add Authorization token if available
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Set the language header
    config.headers.language = i18n.language || "de";
    return config;
  });

  return http;
};
